import { zeitsynchronisationsart } from '../../../../utils/apiTypes';
import { zeitsynchronisationsartState } from './zeitsynchronisationsartTypes';
import { AnyAction, createSlice, PayloadAction, ThunkAction } from "@reduxjs/toolkit";
import { getWithAuth, putWithAuth, deleteWithAuth } from "../../../../utils/api";
import type { RootState, AppDispatch } from "../../../../app/store";
import { logError } from "../../../../utils/utils";
import { openSnackbar } from "../../../../features/snackbar/globalSnackbarSlice";
import { GridSortModel } from '@material-ui/data-grid';
import { errorHandler } from '../../../../utils/errorHandling';

export const zeitsynchronisationsartDummy: zeitsynchronisationsart
  = {
  name: "",
  kommentar: "",
  zugeordnet: false
};

const initialState: zeitsynchronisationsartState
  = {
  zeitsynchronisationsartListe: [],
  alteZeitsynchronisationsart: zeitsynchronisationsartDummy,
  aktuelleZeitsynchronisationsart: zeitsynchronisationsartDummy,
  newEntry: false,
  editEntry: false,
  editDirty: 0,
  viewMode: false,
  error: [],
  listLoading: false,
  sorting: [
    {
      field: 'name',
      sort: 'asc',
    },
  ]
};

const zeitsynchronisationsartSlice = createSlice({
  name: "zeitsynchronisationsart",
  initialState,
  reducers:
  {
    updateZeitsynchronisationsartListe: (state, action: PayloadAction<zeitsynchronisationsart>) => {
      const updateIndex = state.zeitsynchronisationsartListe.findIndex(
        (x: zeitsynchronisationsart) => x.name == action.payload.name
      );
      const firstPart = state.zeitsynchronisationsartListe.slice(0, updateIndex);
      let lastPart = Array<zeitsynchronisationsart>();
      if (updateIndex + 1 < state.zeitsynchronisationsartListe.length)
        lastPart = state.zeitsynchronisationsartListe.slice(updateIndex + 1);
      state.zeitsynchronisationsartListe = [...firstPart, action.payload, ...lastPart].sort((a, b) => a.name.localeCompare(b.name));
    },
    removeFromZeitsynchronisationsartListe: (state, action: PayloadAction<zeitsynchronisationsart>) => {
      const updateIndex = state.zeitsynchronisationsartListe.findIndex(
        (x) => x.name == action.payload.name
      );
      const firstPart = state.zeitsynchronisationsartListe.slice(0, updateIndex);
      let lastPart = Array<zeitsynchronisationsart>();
      if (updateIndex + 1 < state.zeitsynchronisationsartListe.length)
        lastPart = state.zeitsynchronisationsartListe.slice(updateIndex + 1);
      state.zeitsynchronisationsartListe = [...firstPart, ...lastPart];
    },
    addAktuelleZeitsynchronisationsartToZeitsynchronisationsartListe: (state) => {
      const wandlerArray = state.zeitsynchronisationsartListe;
      wandlerArray.push(state.aktuelleZeitsynchronisationsart);
      state.zeitsynchronisationsartListe = [...wandlerArray].sort((a, b) => a.name.localeCompare(b.name));
    },
    setZeitsynchronisationsartListe: (state, action: PayloadAction<Array<zeitsynchronisationsart>>) => {
      state.zeitsynchronisationsartListe = action.payload;
    },
    setAktuelleZeitsynchronisationsart: (state, action: PayloadAction<zeitsynchronisationsart>) => {
      state.aktuelleZeitsynchronisationsart = action.payload;
      state.alteZeitsynchronisationsart = action.payload;
    },
    setAlteZeitsynchronisationsart: (state, action: PayloadAction<zeitsynchronisationsart>) => {
      state.alteZeitsynchronisationsart = action.payload;
    },
    resetAktuelleZeitsynchronisationsart: (state) => {
      state.aktuelleZeitsynchronisationsart = state.alteZeitsynchronisationsart;
    },
    setEditEntry: (state) => {
      state.editEntry = true;
    },
    resetEditEntry: (state) => {
      state.editEntry = false;
    },
    setNewEntry: (state) => {
      state.newEntry = true;
    },
    resetNewEntry: (state) => {
      state.newEntry = false;
    },
    resetEditDirty: (state) => {
      state.editDirty = 0;
    },
    setViewMode: (state) => {
      state.viewMode = true;
    },
    resetViewMode: (state) => {
      state.viewMode = false;
    },
    setError: (state, action: PayloadAction<string>) => {
      if (!state.error.includes(action.payload)) {
        state.error.push(action.payload);
      }
    },
    resetError: (state, action: PayloadAction<string>) => {
      if (state.error.includes(action.payload)) {
        state.error.splice(state.error.indexOf(action.payload), 1)
      }
    },
    setName: (state, action: PayloadAction<string>) => {
      state.aktuelleZeitsynchronisationsart.name = action.payload;
      state.editDirty =
        state.aktuelleZeitsynchronisationsart.name ==
          state.alteZeitsynchronisationsart.name
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setKommentar: (state, action: PayloadAction<string>) => {
      state.aktuelleZeitsynchronisationsart.kommentar = action.payload;
      state.editDirty =
        state.aktuelleZeitsynchronisationsart.kommentar ==
          state.alteZeitsynchronisationsart.kommentar
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setListLoading: (state, action: PayloadAction<boolean>) => {
      state.listLoading = action.payload;
    },
    setSorting: (state, action: PayloadAction<GridSortModel>) => {
      state.sorting = action.payload;
    },
  }
});


//Selectors
//======================================================================
export const selectZeitsynchronisationsartListe = (state: RootState): Array<zeitsynchronisationsart> =>
  state.zeitsynchronisationsart.zeitsynchronisationsartListe;
export const selectAktuelleZeitsynchronisationsart = (state: RootState): zeitsynchronisationsart =>
  state.zeitsynchronisationsart.aktuelleZeitsynchronisationsart;
export const selectEditEntry = (state: RootState): boolean =>
  state.zeitsynchronisationsart.editEntry;
export const selectNewEntry = (state: RootState): boolean => state.zeitsynchronisationsart.newEntry;
export const selectEditDirty = (state: RootState): number =>
  state.zeitsynchronisationsart.editDirty;
export const selectViewMode = (state: RootState): boolean => state.zeitsynchronisationsart.viewMode;
export const selectError = (state: RootState): boolean => state.zeitsynchronisationsart.error.length > 0;
export const selectListLoading = (state: RootState): boolean => state.zeitsynchronisationsart.listLoading;
export const selectSorting = (state: RootState): GridSortModel => state.zeitsynchronisationsart.sorting;

//Actions
//=====================================================================

export const getZeitsynchronisationsartListe = (url: string, typ: string) => (dispatch: AppDispatch): void => {
  dispatch(setListLoading(true));
  getWithAuth(url, {})
    .then((response) => {
      dispatch(setZeitsynchronisationsartListe(response));
    })
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));
};

export const updateZeitsynchronisationsart = (aktuelleZeitsynchronisationsart: zeitsynchronisationsart, url: string, typ: string): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setListLoading(true));
  putWithAuth(url , {}, aktuelleZeitsynchronisationsart, aktuelleZeitsynchronisationsart.name)
    .then(() => {
      dispatch(
        openSnackbar({
          message: `${typ} mit Name ${aktuelleZeitsynchronisationsart.name} wurde erfolgreich geändert.`,
          severity: "success",
          duration: 6000,
        })
      );
      dispatch(setAlteZeitsynchronisationsart(aktuelleZeitsynchronisationsart));
      dispatch(updateZeitsynchronisationsartListe(aktuelleZeitsynchronisationsart));
      dispatch(resetEditEntry());
      dispatch(resetNewEntry());
      dispatch(resetEditDirty());
    }
    )
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));

};

export const updateAktuelleZeitsynchronisationsart = (aktuelleZeitsynchronisationsart: zeitsynchronisationsart): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setAktuelleZeitsynchronisationsart(aktuelleZeitsynchronisationsart));
  dispatch(setViewMode());
};

export const discardChanges = () => (dispatch: AppDispatch): void => {
  dispatch(resetAktuelleZeitsynchronisationsart());
  dispatch(resetEditEntry());
  dispatch(resetNewEntry());
  dispatch(resetEditDirty());
};

export const discardNew = () => (dispatch: AppDispatch): void => {
  dispatch(resetAktuelleZeitsynchronisationsart());
  dispatch(resetEditEntry());
  dispatch(resetNewEntry());
  dispatch(resetEditDirty());
  dispatch(resetViewMode());
};

export const startNewEntry = () => (dispatch: AppDispatch): void => {
  dispatch(setNewEntry());
  dispatch(setAktuelleZeitsynchronisationsart(zeitsynchronisationsartDummy));
  dispatch(setEditEntry());
  dispatch(setViewMode());
};

export const createZeitsynchronisationsart = (aktuelleZeitsynchronisationsart: zeitsynchronisationsart, url: string, typ: string): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setListLoading(true));
  putWithAuth(url , {}, aktuelleZeitsynchronisationsart, aktuelleZeitsynchronisationsart.name)
    .then(() => {
      dispatch(
        openSnackbar({
          message: `${typ} mit Name ${aktuelleZeitsynchronisationsart.name} wurde erfolgreich angelegt.`,
          severity: "success",
          duration: 6000,
        })
      );
      dispatch(addAktuelleZeitsynchronisationsartToZeitsynchronisationsartListe());
      dispatch(setAktuelleZeitsynchronisationsart(zeitsynchronisationsartDummy));
      dispatch(resetEditEntry());
      dispatch(resetNewEntry());
      dispatch(resetEditDirty());
      dispatch(resetViewMode());
    }
    )
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));

};

export const deleteZeitsynchronisationsart = (aktuelleZeitsynchronisationsart: zeitsynchronisationsart, url: string): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setListLoading(true));
  deleteWithAuth(url, { name: aktuelleZeitsynchronisationsart.name }, aktuelleZeitsynchronisationsart.name)
    .then(() => {
      dispatch(setAktuelleZeitsynchronisationsart(zeitsynchronisationsartDummy));
      dispatch(removeFromZeitsynchronisationsartListe(aktuelleZeitsynchronisationsart));
      dispatch(resetEditEntry());
      dispatch(resetEditDirty());
      dispatch(resetViewMode());
      dispatch(openSnackbar({
        message: `${aktuelleZeitsynchronisationsart.name} wurde erfolgreich gelöscht.`,
        severity: "success",
        duration: 6000,
      }));
    }
    )
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));
};

export const {
  removeFromZeitsynchronisationsartListe,
  setZeitsynchronisationsartListe,
  setAktuelleZeitsynchronisationsart,
  resetAktuelleZeitsynchronisationsart,
  setAlteZeitsynchronisationsart,
  updateZeitsynchronisationsartListe,
  setEditEntry,
  resetEditEntry,
  setNewEntry,
  resetNewEntry,
  resetEditDirty,
  setViewMode,
  resetViewMode,
  setError,
  resetError,
  setName,
  setKommentar,
  addAktuelleZeitsynchronisationsartToZeitsynchronisationsartListe,
  setListLoading,
  setSorting
} = zeitsynchronisationsartSlice.actions;
export default zeitsynchronisationsartSlice.reducer;